import { Box, Grid } from '@mui/material'
import { RightProps } from './type'
import { useStyles } from './styles'
import { ItemsSection } from '../../components/itemsSection'
import { QuestionsSection } from '../../components/questionsSection'
import { InstructionsSection } from '../../components/instructionsSection'
import { GeneralEvidencesSection } from '../../components/generalEvidencesSection'
import { QuestionWithEvidencesSection } from '../../components/questionWithEvidencesSection'
import { PlanResponsesSection } from '../../components/planResponsesSection'

function Right({
  mode,
  items,
  detailCreation,
  detailQuestions,
  description,
  evidences,
  id,
  answerActionPlan,
  aproveDisable,
  showActions,
  onApprove,
  onReject,
  isManualModule,
}: RightProps) {
  const styles = useStyles()

  return (
    <Box sx={styles.container}>
      {mode === 'items-questions' && (
        <>
          {!!description && <InstructionsSection instructions={description} />}

          <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <Box sx={styles.scrollableSection}>
                <ItemsSection items={items} scrollable />
              </Box>
            </Grid>

            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <Box sx={styles.scrollableSection}>
                <QuestionsSection detailCreation={detailCreation} detailQuestions={detailQuestions} isManualModule={isManualModule} scrollable />
              </Box>
            </Grid>
          </Grid>

          <GeneralEvidencesSection evidences={evidences} id={id} />
        </>
      )}

      {mode === 'items-single-question' && (
        <>
          {!!description && <InstructionsSection instructions={description} />}

          <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <Box sx={styles.scrollableSection}>
                <ItemsSection items={items} scrollable />
              </Box>
            </Grid>

            <Grid item xl={6} lg={6} md={12} sm={12} xs={12}>
              <Box sx={styles.scrollableSection}>
                <QuestionsSection detailCreation={detailCreation} detailQuestions={detailQuestions} isManualModule={isManualModule} scrollable />
              </Box>
            </Grid>
          </Grid>

          <GeneralEvidencesSection evidences={evidences} id={id} />
        </>
      )}

      {mode === 'items-only' && (
        <>
          {!!description && <InstructionsSection instructions={description} />}

          <Box sx={{ width: '100%' }}>
            <ItemsSection items={items} />
          </Box>

          <GeneralEvidencesSection evidences={evidences} id={id} />
        </>
      )}

      {mode === 'questions-only' && (
        <>
          {!!description && <InstructionsSection instructions={description} />}

          <QuestionWithEvidencesSection
            detailCreation={detailCreation}
            detailQuestions={detailQuestions}
            id={id}
          />

        </>
      )}

      <PlanResponsesSection
        answerActionPlan={answerActionPlan}
        aproveDisable={aproveDisable}
        showActions={showActions}
        onApprove={onApprove}
        onReject={onReject}
      />
    </Box>
  )
}

export default Right
